export interface NavItem {
  key: string;
  label: string;
  icon: string;
  path: string;
}

/** Sidebar navigation in display order. Role filtering uses ROLE_NAV in roles.ts. */
export const NAV_ITEMS: NavItem[] = [
  { key: "dashboard", label: "Dashboard", icon: "ri-dashboard-line", path: "/" },
  { key: "members", label: "Members", icon: "ri-group-line", path: "/members" },
  { key: "groups", label: "Groups", icon: "ri-archive-line", path: "/groups" },
  { key: "auction", label: "Auction", icon: "ri-hammer-line", path: "/auction" },
  { key: "collection", label: "Collection", icon: "ri-wallet-3-line", path: "/collection" },
  { key: "payout", label: "Payout", icon: "ri-bank-line", path: "/payout" },
  { key: "reports", label: "Reports", icon: "ri-bar-chart-box-line", path: "/reports" },
  { key: "settings", label: "Settings", icon: "ri-settings-3-line", path: "/settings" },
];

export const GALLERY_PATH = "/gallery";